import { Compound } from 'pubchem';

/**
 * We check that the hazards are present in the reagents
 * @param {object} reagent
 */
export async function ensureHHazardAndPhysical(reagent, options = {}) {
  const { logger } = options;
  if (reagent.hazards) return;

  try {
    const compound = await Compound.fromSmiles(reagent.smiles);
    const data = await compound.getData();
    const hStatements = data.getGHS().hStatements;
    reagent.hStatements = hStatements;

    const allCodes = hStatements.map((h) => h.data.map((d) => d.code)).flat();
    const uniqueHs = [...new Set(allCodes).keys()];
    reagent.hazards = uniqueHs;
  } catch (e) {
    logger.error(`Could not get hazards for ${reagent.smiles}: ${e.toString()}`);
    reagent.hStatements = []
    reagent.hazards = []
  }

}
